// Zentrale Rechte-Prüfung im Frontend. Einzige Quelle ist das Backend: `/auth/me` liefert
// `user.permissions` (Capability -> bool) aus permissions.py. So entsteht kein Frontend/Backend-
// Drift mehr — die SPA interpretiert keine Rollen-Arrays selbst.
export function can(user, capability) {
  return Boolean(user?.permissions?.[capability]);
}
